import React from 'react';
import { T } from 'shared/helper/translate';
var OrderService = function OrderService(_ref) {
  var removable = _ref.removable,
    service = _ref.service,
    _ref$actions = _ref.actions,
    Actions = _ref$actions === void 0 ? function () {
      return null;
    } : _ref$actions;
  return /*#__PURE__*/React.createElement("div", {
    className: "order-service-name ".concat(removable ? 'removable-service' : ''),
    key: service.id || service.key
  }, /*#__PURE__*/React.createElement(Actions, null), /*#__PURE__*/React.createElement(T, {
    source: service.name
  }));
};
export default OrderService;